import { ABaseModel } from '../abstracts/ABaseModel.js';
import {
  IPageMeta,
  IUrlRedirector,
  IUrlRedirectorPaginationResult,
  IMetaCategory,
  IUrlMeta,
  IUrlMetaLocale,
} from '../interfaces/Meta.js';
import { PaginationResult } from './List.js';
import { Image } from './Image.js';

/**
 * PageMeta
 */
class PageMeta extends ABaseModel implements IPageMeta {
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  pageTitle: string;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * UrlRedirector
 */
class UrlRedirector extends ABaseModel implements IUrlRedirector {
  id: number;
  requestUri: string;
  targetUri: string;
  parentType: string;
  parentId: number;
  redirect: boolean;
  redirectCode: number;
  redirectorName: string;
  system: boolean;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * CollectionPaginationResult
 */
class UrlRedirectorPaginationResult extends PaginationResult implements IUrlRedirectorPaginationResult {
  declare items: Array<UrlRedirector>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * MetaCategory
 */
class MetaCategory extends ABaseModel implements IMetaCategory {
  id: number;
  active: boolean;
  domain: string;
  title: string;
  description: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  pageTitle: string;
  images: Array<Image>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * UrlMeta
 */
class UrlMeta extends ABaseModel implements IUrlMeta {
  id: number;
  moduleName: string;
  controllerName: string;
  actionName: string;
  requestUri: string;
  parentType: string;
  parentId: number;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  ssl: boolean;
  pageTitle: string;
  locales: Array<IUrlMetaLocale>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * UrlMetaLocale
 */
class UrlMetaLocale extends ABaseModel implements IUrlMetaLocale {
  id: number;
  localeCode: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  pageTitle: string;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

export { PageMeta, UrlRedirector, UrlRedirectorPaginationResult, MetaCategory, UrlMeta, UrlMetaLocale };
